import PremiumButton from '@/app/[locale]/(worlds)/[roomId]/components/PremiumButton'
import PremiumPopoverButton from '@/app/[locale]/(worlds)/[roomId]/components/PremiumPopoverButton'
import IconDiamond from '@/components/assets/icon_diamond_check.svg'
import { Badge } from '@/components/ui/badge'
import { useUAContext } from '@/context/UAContext'
import { useTranslations } from 'next-intl'

const DiamondCheckBadge = () => {
  return (
    <Badge className="h-[34px] min-w-[40px] rounded-full border-[1.5px] border-transparent px-4 py-1 transition-all [background:linear-gradient(#000,#000)_padding-box,var(--background-image-gradient-btn)_border-box] [&>svg]:size-5">
      <IconDiamond />
    </Badge>
  )
}

type PremiumAccessButtonProps = {
  isPaid?: boolean
  page: 'profile' | 'detail'
  communityUserId?: string
  'data-component'?: string
}

export default function PremiumAccessButton({
  isPaid,
  page,
  communityUserId,
  'data-component': dataComponent,
}: PremiumAccessButtonProps) {
  const t = useTranslations()
  const { isMobile } = useUAContext()
  if (isPaid === undefined) return null

  if (page === 'profile') {
    return isPaid ? (
      <PremiumPopoverButton label={t('profile-page.premium-popover.label-premium-unlocked')} data-component={dataComponent} />
    ) : (
      <PremiumButton
        label={t('profile-page.premium-button.label-premium-unlock')}
        communityUserId={communityUserId}
        className="h-8.5 text-sm md:h-12 md:text-base"
        data-component={dataComponent}
      />
    )
  }

  if (page === 'detail') {
    return isPaid ? (
      <DiamondCheckBadge />
    ) : (
      <PremiumButton
        label={isMobile ? '' : t('world-info.premium-button.label-get-premium')}
        className={isMobile ? 'px-4 py-[7px]' : ''}
        communityUserId={communityUserId}
        data-component={dataComponent}
      />
    )
  }

  return null
}
